import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router';
import Globals from './utils/Globals';
import auth from './utils/Auth';
import Init from './utils/Init';

const PrivateRoute = ({ component: Component, ...props }) => {
    const [isInit, initLoaded] = useState(Globals.user !== null);
    const navigate = useNavigate();
    useEffect(() => {
        if (Globals.user === null) {
            Init.initAfterLogin({
                success: () => {
                    const firstLink = Globals.actions.getFirstLink();
                    if (location.pathname === '/' && firstLink === 'index.reports' && Globals.user.get('startReportSaved_id') !== null) {
                        navigate('/index.reports/' + Globals.user.get('startReportSaved_id'), { replace: true });
                    } else if (location.pathname === '/') {
                        navigate('/' + firstLink, { replace: true });
                    }
                    initLoaded(true);
                },
            });
        }
    }, []);
    const samlEnabled = Globals.saml;
    const location = useLocation();
    const saml = localStorage.getItem('saml');
    const isSaml = localStorage.getItem('isSaml');
    if ((auth.loggedIn() && (!samlEnabled || isSaml === 'false')) || (auth.loggedIn() && samlEnabled && location.pathname !== '/') || (auth.loggedIn() && samlEnabled && saml === 'true')) {
        if (isInit) {
            localStorage.removeItem('saml');
            return <Component {...props} />;
        }
        return null;
    } else if (samlEnabled) {
        localStorage.setItem('saml', 'true');
        localStorage.setItem('isSaml', 'true');
        return <Navigate to="/saml/login" state={{ from: location }} />;
    } else {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
};

export default PrivateRoute;
